export default __webpack_public_path__ + "static/media/enigma.f4288ccc.png";